export const entitiesSelector = (entity) => (state) =>
  Object.values(state.entities?.[entity] ?? {}).sort((a, b) => {
    const priorityDiff = (a.priority ?? 0) - (b.priority ?? 0);

    if (priorityDiff !== 0) {
      return priorityDiff;
    }

    return (
      new Date(b.updatedAt ?? 0).getTime() -
      new Date(a.updatedAt ?? 0).getTime()
    );
  });
export const entitySelector = (entity, id) => (state) =>
  state.entities?.[entity]?.[id];
export const entityFormSelector = (entity, id) => (state) =>
  state.edition?.[entity]?.[id];
export const isEntityReadySelector = (entity) => (state) =>
  state.navigation?.[entity]?.ready ?? false;

export const experienceCategorySelector = (id) => (state) => {
  const categories = entitiesSelector('experienceCategories')(state);
  let category = categories.find((category) => category.id === id);
  const categoryFamily = [category];

  while (category.parentId) {
    const parentId = category.parentId;
    const parentCategory = categories.find((c) => c.id === parentId);

    categoryFamily.push(parentCategory);
    category = parentCategory;
  }

  return categoryFamily;
};

export const isReadySelector = (entity) => (state) =>
  state.navigation?.[entity]?.ready;
export const isLoadingSelector = (entity) => (state) =>
  state.navigation?.[entity]?.loading ?? false;

export const entityCountrySelector = (entity) => (state) => {
  if (!entity) {
    return undefined;
  }

  if (entity.countryId) {
    return entitySelector('countries', entity.countryId)(state);
  }

  if (entity.clubId) {
    const club = entitySelector('clubs', entity.clubId)(state);

    return entitySelector('countries', club.countryId)(state);
  }

  if (entity.hotelId) {
    const hotel = entitySelector('hotels', entity.hotelId)(state);

    return entitySelector('countries', hotel?.countryId)(state);
  }

  return undefined;
};
export const localeSelector = (entity) => (state) => {
  const entityCountry = entityCountrySelector(entity)(state);

  if (entityCountry) {
    return entityCountry.locale;
  }

  return undefined;
};
export const currencySelector = (entity) => (state) => {
  // Used on table cells
  const entityCountry = entityCountrySelector(entity)(state);

  if (entityCountry) {
    return entityCountry.currency;
  }

  if (entity.accountId) {
    const payoutAccount = entitySelector(
      'payoutAccounts',
      entity.accountId
    )(state);

    return payoutAccount.currency;
  }

  return undefined;
};
export const currencySymbolSelector = (state) => {
  // Used for price inputs
  const currency = state.navigation?.currency;

  return currency
    ? Number()
        .toLocaleString('en-US', { style: 'currency', currency })
        .slice(0, 1)
    : 'XXX';
};

export const searchParamsSelector = (state) => state.router?.location?.search;
export const urlParamSelector = (key, defaultValue) => (state) =>
  new URLSearchParams(searchParamsSelector(state)).get(key) || defaultValue;
export const urlParamsSelector = (state) => {
  const urlParams = new URLSearchParams(searchParamsSelector(state));

  return Object.fromEntries(urlParams.entries());
};
